export const tags = [
    { id: 'entities', label: 'Entities' },
    { id: 'recommendations', label: 'Recommendations' },
];
